import React, { useState, useEffect } from 'react';
import NavigationBar from '../NavigationBar';
import axios from '../axios';
import { Container, Row, Col, Table, Button, Form, Modal, Badge } from 'react-bootstrap';

const emptyMaterial = { name: '', category: '', unitName: 'kg', minStockQty: '', isActive: true };

function IndirectMaterials() {
    const [materials, setMaterials] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [form, setForm] = useState(emptyMaterial);
    const [editingId, setEditingId] = useState(null);

    useEffect(() => { fetchMaterials(); }, []);

    const fetchMaterials = async () => {
        try {
            const res = await axios.get(`${window.backendUrl}/indirect_materials`);
            setMaterials(res.data.data || []);
        } catch (err) {
            console.error('Error fetching materials:', err);
        }
    };

    const openAdd = () => { setForm(emptyMaterial); setEditingId(null); setShowModal(true); };
    const openEdit = (m) => {
        setForm({ name: m.Name, category: m.Category || '', unitName: m.UnitName || 'kg', minStockQty: m.MinStockQty ?? '', isActive: !!m.IsActive });
        setEditingId(m.MaterialID);
        setShowModal(true);
    };

    const handleChange = (field, value) => setForm(prev => ({ ...prev, [field]: value }));

    const handleSave = async () => {
        if (!form.name) { alert('Name is required'); return; }
        try {
            if (editingId) {
                await axios.put(`${window.backendUrl}/indirect_materials/${editingId}`, form);
            } else {
                await axios.post(`${window.backendUrl}/indirect_materials`, form);
            }
            setShowModal(false);
            fetchMaterials();
        } catch (err) {
            console.error('Error saving material:', err);
            alert('Failed to save. Name may already exist.');
        }
    };

    return (
        <>
            <NavigationBar />
            <Container fluid style={{ marginTop: 20 }}>
                <Row className="align-items-center mb-3">
                    <Col xs="auto"><h3>Indirect Materials</h3></Col>
                    <Col>
                        <p className="text-muted mb-0">Raw materials other than paper — ink, glue, stitching wire, etc. Paper (Direct) still uses the existing GSM list under Manage Data.</p>
                    </Col>
                    <Col xs="auto"><Button variant="primary" onClick={openAdd}>+ Add Material</Button></Col>
                </Row>
                <Table striped bordered hover responsive size="sm">
                    <thead>
                        <tr><th>Name</th><th>Category</th><th>Unit</th><th>Min stock</th><th>Active</th><th>Edit</th></tr>
                    </thead>
                    <tbody>
                        {materials.length === 0 ? (
                            <tr><td colSpan={6} className="text-center text-muted" style={{ padding: 20 }}>No indirect materials yet.</td></tr>
                        ) : materials.map(m => (
                            <tr key={m.MaterialID}>
                                <td>{m.Name}</td>
                                <td>{m.Category || '-'}</td>
                                <td>{m.UnitName}</td>
                                <td>{m.MinStockQty ?? '-'}</td>
                                <td>{m.IsActive ? <Badge bg="success">Active</Badge> : <Badge bg="secondary">Inactive</Badge>}</td>
                                <td><Button size="sm" variant="outline-primary" onClick={() => openEdit(m)}>Edit</Button></td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </Container>

            <Modal show={showModal} onHide={() => setShowModal(false)} centered>
                <Modal.Header closeButton><Modal.Title>{editingId ? 'Edit' : 'Add'} Material</Modal.Title></Modal.Header>
                <Modal.Body>
                    <Form.Group className="mb-2">
                        <Form.Label>Name</Form.Label>
                        <Form.Control value={form.name} onChange={e => handleChange('name', e.target.value)} placeholder="e.g. Yellow Ink" />
                    </Form.Group>
                    <Form.Group className="mb-2">
                        <Form.Label>Category</Form.Label>
                        <Form.Control value={form.category} onChange={e => handleChange('category', e.target.value)} placeholder="e.g. Ink, Glue, Stitching wire" />
                    </Form.Group>
                    <Row>
                        <Col>
                            <Form.Group className="mb-2">
                                <Form.Label>Unit</Form.Label>
                                <Form.Control value={form.unitName} onChange={e => handleChange('unitName', e.target.value)} placeholder="kg / litre / pcs" />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-2">
                                <Form.Label>Minimum stock (warn below)</Form.Label>
                                <Form.Control type="number" value={form.minStockQty} onChange={e => handleChange('minStockQty', e.target.value)} />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Form.Check type="checkbox" label="Active" checked={form.isActive} onChange={e => handleChange('isActive', e.target.checked)} />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>Cancel</Button>
                    <Button variant="primary" onClick={handleSave}>Save</Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default IndirectMaterials;
